export default __webpack_public_path__ + "static/media/help-center.ad292376.svg";